import styled from 'styled-components';
import ReactBarLoader from 'react-bar-loader';
import colors from '~/styles/colors';

export const BarLoader = styled(ReactBarLoader).attrs({
  color: props => props.color || colors.primary,
  height: props => props.height || 25,
})`
  flex: 1;
  display: flex;
`;
